import { createRouter, createWebHistory } from "vue-router";
import AppHome from "../components/AppHome.vue";
import AppDev from "../components/AppDeveloper.vue";
import AppLogin from "../components/AppLogin.vue";
import AppProfile from "../components/AppProfile.vue";
import AppNotFound from "../components/AppNotFound.vue";
import AppForbidden from "../components/AppForbidden.vue";
import AppCondena from "../components/AppCondena.vue";
import { isAuthenticated } from "../auth";
import AppGogoPoints from "@/components/AppGogoPoints.vue";
import AppConstruccion from "@/components/AppConstruccion.vue";
import AppRegister from "@/components/AppRegister.vue";
import AppFurina from "@/components/AppFurina.vue";
import AppTermsOfService from "@/components/AppTermsOfService.vue";
import AppProject from "@/components/AppProject.vue";
import AppCondenaExtendida from "@/components/AppCondenaExtendida.vue";
import AppFeed from "@/components/AppFeed.vue";
import AppEmailVerification from "@/components/AppEmailVerification.vue";
import AppPasswordReset from "@/components/AppPasswordReset.vue";

import AppPostDetail from '../components/AppPostDetail.vue';
const routes = [
  {
    path: '/post/:id',
    name: 'PostDetail',
    component: AppPostDetail,
    beforeEnter: (to, from, next) => {
      if (isAuthenticated()) next();
      else next('/forbidden');
    },
  },
  { path: "/", component: AppHome },
  { path: "/dev", component: AppDev },
  { path: "/proyect", component: AppProject },
  { path: "/app", component: AppConstruccion },
  { path: "/condena", component: AppCondena },
  { path: "/condena/biblia", component: AppCondenaExtendida },
  { path: "/proyect/terms-of-service", component: AppTermsOfService },
  { path: "/login", component: AppLogin },
  { path: "/register", component: AppRegister },
  { path: "/verify-email", component: AppEmailVerification },
  { path: "/reset-password", component: AppPasswordReset },
  { path: "/furina", component: AppFurina },
  { path: "/gogopoints", component: AppGogoPoints },
  {
    path: "/feed",
    component: AppFeed,
    beforeEnter: (to, from, next) => {
      if (isAuthenticated()) next();
      else next("/forbidden");
    },
  },
  {
    path: "/profile",
    beforeEnter: (to, from, next) => {
      if (!isAuthenticated()) {
        next("/forbidden");
        return;
      }
      // Obtener nickname del usuario logueado
      const nickname = localStorage.getItem('userNickname');
      if (nickname) {
        next(`/profile/${nickname}`);
      } else {
        next("/forbidden");
      }
    },
  },
  {
    path: "/profile/:nickname",
    component: AppProfile,
    beforeEnter: (to, from, next) => {
      if (isAuthenticated()) next();
      else next("/forbidden");
    },
  },
  {
    path: "/:nickname",
    component: AppProfile,
    beforeEnter: (to, from, next) => {
      // Verificar que el nickname no sea una ruta especial
      const specialRoutes = ['dev', 'proyect', 'app', 'condena', 'login', 'register', 'verify-email', 'furina', 'gogopoints', 'profile', 'forbidden'];
      if (specialRoutes.includes(to.params.nickname)) {
        next();
        return;
      }
      
      if (isAuthenticated()) next();
      else next("/forbidden");
    },
  },
  { path: "/forbidden", component: AppForbidden },
  { path: "/:pathMatch(.*)*", component: AppNotFound },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;